const homeTopSelect = document.querySelector('.quick-nav-top > select');
const pageLoader = document.querySelector('[data-page-loader]');
const crosslinkSelect = document.querySelector('.quick-nav-crosslink > select');

export default function initQuickNav() {
  if (homeTopSelect) {
    homeTopSelect.addEventListener('change', (e) => {
      pageLoader.classList.remove('hidden');
      window.location.href = e.target.value;
    });
  }

  if (crosslinkSelect) {
    crosslinkSelect.addEventListener('change', (e) => {
      pageLoader.classList.remove('hidden');
      window.location.href = e.target.value;
    });
  }
}
